import { Button } from "components/DesignSystem/Button/Button";
import { ReferralBannerIcon } from "components/icons/ReferralBannerIcon";
import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import CopyIcon from "static/images/CopyPurple.svg";
import { COPIED_TEXT, FAILED_COPIED_TEXT } from "constants/documents";
import { useToast } from "hooks/useToast";
import { ConditionalLink } from "components/conditionalLink";
import ReferWhatsApp from "static/images/ReferWhatsApp.svg";
import ReferLinkedIn from "static/images/ReferLinkedIn.svg";
import ReferTwitter from "static/images/ReferTwitter.svg";
import ReferMail from "static/images/ReferMail.svg";
import { getSocialRedirctLinks } from "components/ReferHomeCard/ReferHomeCard";

export const ReferralBanner = () => {
  const {
    authtoken: { referral_link },
  } = useContext(authContext);
  const { alertToast, successToast } = useToast();

  const linkedInReferralLink = encodeURIComponent(referral_link);

  const mailLink = getSocialRedirctLinks({
    type: "mail",
    referralLink: referral_link,
  });
  const twitterLink = getSocialRedirctLinks({
    type: "twitter",
    referralLink: referral_link,
  });
  const linkedInLink = getSocialRedirctLinks({
    type: "linkedin",
    referralLink: linkedInReferralLink,
  });
  const whatsAppLink = getSocialRedirctLinks({
    type: "whatsapp",
    referralLink: referral_link,
  });

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(referral_link);
      successToast({ message: COPIED_TEXT });
    } catch (err) {
      alertToast({ message: FAILED_COPIED_TEXT });
    }
  };

  return (
    <div className="t-h-[195px] sm:t-h-auto t-w-full t-bg-refferal-gradient t-rounded-lg t-border t-border-solid t-border-neutral-10 t-flex t-justify-between">
      <div className="t-p-6 t-h-fit t-min-w-0 sm:t-p-4">
        <div className="t-text-subtext t-text-text-100">
          Invite a founder, earn $100 each
        </div>
        <div className="t-text-body-sm t-text-text-30 t-pt-1.5">
          Refer someone to Inkle. When they join, you both receive $100 in Inkle
          credits.
          <br />
          Your credits act like cash. Use them to save big on filings,
          bookkeeping, and more!
        </div>
        <div
          onClick={copyToClipBoard}
          className="t-w-[25rem] t-max-w-[30rem] sm:t-w-full sm:t-max-w-full sm:t-gap-2 t-bg-white t-h-9 t-border t-border-solid t-border-surface-grey t-rounded t-mt-4 t-mb-2 t-flex t-justify-between t-px-3 t-items-center t-shadow-light-30 t-cursor-pointer"
        >
          <div className="sm:t-min-w-0 sm:t-truncate t-text-body-sm t-text-text-60">
            {referral_link}
          </div>
          <Button customType="ghost_icon" size="xsmall">
            <img className="t-h-4 t-w-4" src={CopyIcon} alt="copyIcon" />
          </Button>
        </div>
        <div>
          <div className="t-flex t-gap-2 t-items-center">
            <div className="t-text-neutral t-text-body-sm">
              Share unique link via:
            </div>
            <ConditionalLink to={mailLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img className="t-h-6 t-w-6" src={ReferMail} alt="Mail" />
              </Button>
            </ConditionalLink>
            <ConditionalLink to={twitterLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img className="t-h-6 t-w-6" src={ReferTwitter} alt="Twitter" />
              </Button>
            </ConditionalLink>
            <ConditionalLink to={linkedInLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img
                  className="t-h-6 t-w-6"
                  src={ReferLinkedIn}
                  alt="LinkedIn"
                />
              </Button>
            </ConditionalLink>
            <ConditionalLink to={whatsAppLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img
                  className="t-h-6 t-w-6"
                  src={ReferWhatsApp}
                  alt="WhatsApp"
                />
              </Button>
            </ConditionalLink>
          </div>
        </div>
      </div>
      <div className="sm:t-hidden">
        <ReferralBannerIcon />
      </div>
    </div>
  );
};
